<template>
  <div class="ma-5">
    <SysDataTable
      v-model="localSelected"
      :search="termo_pesquisa"
      :headers="headers"
      :items="desserts"
      item-key="index"
      :height="480"
      color-show-select="#0C75BE"
      :item-height="55"
      show-select
      hide-default-footer
    >
      <template #header.filial>{{ null }}</template>
      <template v-slot:item.filial>{{ null }}</template>

      <template #header.descricao_filial>
        <span class="custom-header">Filial</span>
      </template>

      <template #header.idproduto>
        <span class="custom-header">Cód. Interno</span>
      </template>

      <template #header.descricao_produto>
        <span class="custom-header">Descrição</span>
      </template>

      <template #header.razao_social>
        <span class="custom-header">Fornecedor</span>
      </template>

      <template #header.idfamilia_produto>
        <span class="custom-header">Segmento</span>
      </template>

      <template #header.idcategoria>
        <span class="custom-header">Categoria</span>
      </template>

      <template #header.idsecao>
        <span class="custom-header">Seção</span>
      </template>

      <template #header.status>
        <span class="custom-header">Status</span>
      </template>

      <template v-slot:item.status="{ item }">
        <BadgeProdutosAtivos :value="item.status" />
      </template>

      <template #header.pertence_ao_mix>
        <span class="custom-header">Pertence ao Mix</span>
      </template>

      <template v-slot:item.pertence_ao_mix="{ item }">
        <MixSelect
          v-model="item.pertence_ao_mix"
          :items="pertenceMixSelects"
          @change="() => autoSelectRow(item)"
        />
      </template>

      <template #header.movimentacao>
        <span class="custom-header">Movimentação</span>
      </template>

      <template v-slot:item.movimentacao="{ item }">
        <MixSelect
          v-model="item.movimentacao"
          :items="movimentacaoSelects"
          @change="() => autoSelectRow(item)"
        />
      </template>

      <template #header.classificacao_popularidade>
        <span class="custom-header">Curva Popularidade</span>
      </template>

      <template v-slot:item.classificacao_popularidade="{ item }">
        <span>
          {{ descricao_pqr[item.classificacao_popularidade.toLowerCase()] }}
        </span>
      </template>

      <template #header.classificacao_criticidade>
        <span class="custom-header">Curva Faturamento</span>
      </template>

      <template v-slot:item.classificacao_criticidade="{ item }">
        <span>
          {{ descricao_xyz[item.classificacao_criticidade.toLowerCase()] }}
        </span>
      </template>

      <template v-slot:item.valor_unitario="{ item }">
        {{ formatarValorMonetario(item.valor_unitario) }}
      </template>

      <template #header.valor_unitario>
        <span class="custom-header">Preço de Venda (R$)</span>
      </template>

      <template v-slot:item.valor_unitario="{ item }">
        {{ formatarValorMonetario(item.valor_unitario) }}
      </template>

      <template #header.estoque>
        <span class="custom-header">Saldo de Estoque</span>
      </template>

      <template v-slot:item.estoque="{ item }">
        {{ formatarValor(item.estoque) }}
      </template>

      <template #header.consumo_medio_mensal>
        <span class="custom-header">Projeção de Vendas</span>
      </template>

      <template v-slot:item.consumo_medio_mensal="{ item }">
        {{ formatarValor(item.consumo_medio_mensal) }}
      </template>
    </SysDataTable>
  </div>
</template>

<script>
import BadgeProdutosAtivos from "@/components/MixProdutosFilial/componentes/atomos/BadgeProdutosAtivos.vue";
import DialogUploadModeloMix from "@/components/MixProdutosFilial/componentes/DialogUploadModeloMix.vue";
import MixSelect from "@/components/MixProdutosFilial/componentes/atomos/MixSelect.vue";
import SysDataTable from '@/components/utils/dataTable/sysDataTable/Index.vue';

import { formatarValor, formatarValorMonetario } from "@/helpers";
import api from "@/api/api";
import {
  descricao_pqr,
  descricao_xyz
} from "@/components/Diagnostico/CurvasCruzadas/ParametrizacaoDeCoberturas/CoberturasCurvasPadrao";

export default {
  components: {
    SysDataTable,
    MixSelect,
    BadgeProdutosAtivos,
    DialogUploadModeloMix
  },
  name: "Tabela",
  props: {
    selected: {
      type: Array,
      default: () => []
    },
    filtros: {
      type: Object,
      default: () => ({})
    },
    termo_pesquisa: {
      default: '',
      required: true
    }
  },
  data() {
    return {
      headers: [
        { text: "Filial", value: "filial" },
        { text: "Descrição", value: "descricao_filial" },
        { text: "Cód. SKU", value: "idproduto" },
        { text: "Descrição", value: "descricao_produto" },
        { text: "Fornecedor", value: "razao_social" },
        { text: "Segmento", value: "idfamilia_produto" },
        { text: "Seção", value: "idsecao" },
        { text: "Categoria", value: "idcategoria" },
        { text: "Status", value: "status" },
        { text: "Pertence ao Mix", value: "pertence_ao_mix" },
        { text: "Movimentação", value: "movimentacao" },
        {
          text: "Curva Frequência",
          value: "classificacao_popularidade",
          style: { width: '70px', textAlign: 'center' }
        },
        {
          text: "Curva Faturamento",
          value: "classificacao_criticidade",
          style: { width: '70px', textAlign: 'center' }
        },
        { text: "Preço de Venda (R$)", value: "valor_unitario", style: { width: '100px', textAlign: 'center' } },
        { text: "Saldo de Estoque", value: "estoque", style: { width: '100px', textAlign: 'center' } },
        { text: "Projeção de Vendas", value: "consumo_medio_mensal", style: { width: '100px', textAlign: 'center' } }
      ],
      desserts: [],
      editedItem: null,
      answer: true,
      pertenceMixSelects: [
        { label: 'Sim', value: 'S', color: '#0CB97B', icon: '$CheckCircle' },
        { label: 'Não', value: 'N', color: '#E02244', icon: '$XCircle' },
      ],
      movimentacaoSelects: [
        { label: 'Mista', value: 'MISTA', color: '#40B3FF', icon: '$Swap' },
        { label: 'Retira', value: 'RETIRA', color: '#245AE5', icon: '$ArrowElbowRight' },
        { label: 'Própria', value: 'PROPRIA', color: '#7F48EC', icon: '$ArrowLineDownLeft' }
      ],
    };
  },
  methods: {
    formatarValor,
    formatarValorMonetario,
    buscarProdutos() {
      const body = {
        ...this.filtros
      }

      api.post('mix-produtos-filial', body)
      .then((response) => {
        this.desserts = response.data.produtos;
      }).catch((error) => {
        alert(error);
      });
    },
    itemClass() {
      return 'text-gray-400';
    },
    autoSelectRow(row) {
      const exists = this.localSelected.some(r =>
        r.idproduto === row.idproduto && r.filial === row.filial
      );

      if (!exists) {
        this.localSelected = [...this.localSelected, row]
      }
    }
  },
  watch: {
    filtros: {
      immediate: true,
      deep: true,
      handler() {
        this.buscarProdutos();
      }
    },
  },
  computed: {
    descricao_pqr() {
      return descricao_pqr
    },
    descricao_xyz() {
      return descricao_xyz
    },
    localSelected: {
      get() {
        return this.selected;
      },
      set(val) {
        this.$emit("update:selecionados", val);
      }
    }
  }
};
</script>

<style scoped>
.custom-header {
  color: #19191C;
  font-weight: 500;
  text-align: center;
  font-size: 13px;
  display: flex;
  align-items: center;
}

</style>
